import { FilterChips } from '~/components';

import type { useActivityOptions, useLocationTypeOptions, useRegionOptions } from './hooks';

import { useJobPostFilters } from './JobPosts.nuqs';

type Props = {
  activityOptions: ReturnType<typeof useActivityOptions>;
  locationTypeOptions: ReturnType<typeof useLocationTypeOptions>;
  regionOptions: ReturnType<typeof useRegionOptions>;
};

export const JobPostFilterChips = ({ activityOptions, locationTypeOptions, regionOptions }: Props) => {
  const filters = useJobPostFilters();

  const locationType = filters.locationType.value;
  const hasFilters = locationType !== null || filters.activityIds.value.length > 0 || filters.regions.value.length > 0;

  if (!hasFilters) return null;

  return (
    <FilterChips.Root>
      {locationType !== null && (
        <FilterChips.Chip onRemove={() => filters.locationType.onChange(null)}>
          {locationTypeOptions.find((option) => option.value === locationType)?.label ?? locationType}
        </FilterChips.Chip>
      )}

      {filters.activityIds.value.map((activityId) => (
        <FilterChips.Chip
          key={`activity-${activityId}`}
          onRemove={() => filters.activityIds.onChange(filters.activityIds.value.filter((value) => value !== activityId))}
        >
          {activityOptions.find((option) => option.value === activityId)?.label ?? `${activityId}`}
        </FilterChips.Chip>
      ))}

      {filters.regions.value.map((region) => (
        <FilterChips.Chip
          key={`region-${region}`}
          onRemove={() => filters.regions.onChange(filters.regions.value.filter((value) => value !== region))}
        >
          {regionOptions.find((option) => option.value === region)?.label ?? region}
        </FilterChips.Chip>
      ))}
    </FilterChips.Root>
  );
};
